import { render, staticRenderFns } from "./StockJournalView.vue?vue&type=template&id=e8e90c12"
import script from "./StockJournalView.vue?vue&type=script&lang=js"
export * from "./StockJournalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports